module.exports = __webpack_public_path__ + "img/feature-tile-icon-05.ab53aa2b.svg";